exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@keyframes blinking{0%,to{opacity:0}50%{opacity:1}}@keyframes right-left{0%{left:70%}50%{left:-50%}to{left:100%}}.story{position:absolute;z-index:1;top:50%;left:50%;width:800px;height:600px;background-color:#fff;padding:6px 12px;transform:translateX(-50%) translateY(-50%);border:4px solid #575d6b;box-sizing:border-box}.story .story-content{height:30%}.story .story-content,.story .story-end{position:absolute;top:50%;left:50%;width:60%;transform:translateX(-50%) translateY(-50%)}.story .story-end table td{padding:0 4px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/autoprefixer-loader?{browsers:['last 2 version']}!../~/sass-loader!./components/levels/abstract/level.scss
// module id = 55
// module chunks = 0